import axios from "axios";

/*
 * Get zip_file_data
 */
async function getZipFileData() {
  const url = `${process.env.VUE_APP_API_GATEWAY}getZipFileData?key=${process.env.VUE_APP_API_KEY}`;

  return axios.get(url);
}

/*
 * Save zip_file_data
 */
async function saveZipFileData(uid, formData) {
  const url = `${process.env.VUE_APP_API_GATEWAY}saveZipFileData?uid=${uid}&key=${process.env.VUE_APP_API_KEY}`;

  axios.post(url, formData);
}

/*
 * Delete zip_file_data
 */
async function deleteZipFileData(uid) {
  const url = `${process.env.VUE_APP_API_GATEWAY}deleteZipFileData?uid=${uid}&key=${process.env.VUE_APP_API_KEY}`;

  axios.post(url);
}

export default {
  getZipFileData,
  saveZipFileData,
  deleteZipFileData
};